module.exports = __webpack_public_path__ + "img/logo-jalisco.381833e0.png";